import React from 'react';

const ExpiredInvitePageBackground = props => (
  <svg viewBox="0 0 1440 900" fill="none" preserveAspectRatio="none" {...props}>
    <g opacity="0.39" filter="url(#filter_top_left)">
      <ellipse
        cx="300"
        cy="80"
        rx="250"
        ry="90"
        fill="url(#gradient_top_left)"
      />
    </g>
    <g opacity="0.39" filter="url(#filter_bottom_right)">
      <ellipse
        cx="1350"
        cy="650"
        rx="180"
        ry="65"
        fill="url(#gradient_bottom_right)"
      />
    </g>
    <defs>
      <filter
        id="filter_top_left"
        x="-280"
        y="-340"
        width="1160"
        height="840"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="109.5" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="filter_bottom_right"
        x="720"
        y="135"
        width="1260"
        height="1030"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="109.5" result="effect2_foregroundBlur" />
      </filter>
      <linearGradient
        id="gradient_top_left"
        x1="380"
        y1="300"
        x2="480"
        y2="-80"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65E0FB" />
        <stop offset="0.296875" stopColor="#3A8CF7" />
        <stop offset="0.65625" stopColor="#285AFF" />
        <stop offset="0.973958" stopColor="#5FD3FB" />
      </linearGradient>
      <linearGradient
        id="gradient_bottom_right"
        x1="1400"
        y1="800"
        x2="1470"
        y2="520"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#65E0FB" />
        <stop offset="0.296875" stopColor="#3A8CF7" />
        <stop offset="0.65625" stopColor="#285AFF" />
        <stop offset="0.973958" stopColor="#5FD3FB" />
      </linearGradient>
    </defs>
  </svg>
);

export default ExpiredInvitePageBackground;
